import { configureStore } from '@reduxjs/toolkit'

import configReducer from '@/integrations/redux/slices/configSlice'
import naturalReducer from '@/integrations/redux/slices/naturalSlice'

export const makeStore = () => {
    return configureStore({
        reducer: {
            config: configReducer,
            natural: naturalReducer,
        },
    })
}

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']